<template>
  <div class="row mb-3">
    <div class="col-12 col-m-6 mb-s-3 mb-m-0">
      <slot name="postal"></slot>
    </div>
    <div class="col-12 col-m-6">
      <slot name="place"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PostalCodePlaceWrapper',
};
</script>
